import React from 'react';
import { Rocket, Smartphone, Chrome, BookOpen, GraduationCap, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const Services: React.FC = () => {
  const { t } = useLanguage();

  const services = [
    { icon: Rocket, key: 'development' },
    { icon: Smartphone, key: 'mobile' },
    { icon: Chrome, key: 'extensions' },
    { icon: BookOpen, key: 'ebooks' },
    { icon: GraduationCap, key: 'courses' },
    { icon: Users, key: 'consulting' },
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-semibold mb-3">
            {t('services', 'title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(({ icon: Icon, key }) => (
            <div key={key} className="group">
              <Icon className="w-6 h-6 text-muted-foreground mb-4" />
              <h3 className="text-lg font-medium mb-2">
                {t('services', `${key}.title`)}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {t('services', `${key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
